import React, { useState, useRef, useEffect } from "react";
import { BsThreeDots } from "react-icons/bs";
import { useDispatch } from "react-redux";
import {
  deleteDepartment,
  openDepartment,
  openDepartmentDashboard,
} from "../../store/actions/departmentActions";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

const DepartmentCard = ({ department }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeDropdown);
    return () => {
      document.removeEventListener("mousedown", closeDropdown);
    };
  }, []);

  const handleDelete = (department_id) => {
    confirmAlert({
      message: "Are you sure you want to delete this department?",
      buttons: [
        {
          label: "Yes",
          onClick: () => dispatch(deleteDepartment(department_id)),
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <div className="border border-gray-300 rounded-lg shadow-lg p-4 bg-[#F8F8F8] relative w-full">
      {/* Dropdown Icon */}
      <div className="absolute top-2 right-2" ref={dropdownRef}>
        <button
          className="p-1 rounded-full hover:bg-gray-200"
          onClick={toggleDropdown}
        >
          <BsThreeDots size={20} />
        </button>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-36 bg-white rounded-md shadow-lg border border-gray-300 z-50">
            <div
              className="px-4 py-2 text-sm text-black hover:bg-gray-100 cursor-pointer border-b border-gray-300 mr-2 ml-2"
              onClick={() => {
                dispatch(openDepartment(department.department_id));
                setIsDropdownOpen(false);
              }}
            >
              Edit
            </div>
            <div
              className="px-4 py-2 text-sm text-black hover:bg-gray-100 cursor-pointer border-b border-gray-300 mr-2 ml-2"
              onClick={() => {
                dispatch(openDepartmentDashboard(department.department_id));
                setIsDropdownOpen(false);
              }}
            >
              Stats
            </div>
            <div
              className="px-4 py-2 text-sm text-red-500 hover:bg-gray-100 cursor-pointer ml-2"
              onClick={() => {
                handleDelete(department.department_id);
                setIsDropdownOpen(false);
              }}
            >
              Delete
            </div>
          </div>
        )}
      </div>

      {/* Department Details */}
      <h3 className="text-lg font-bold text-[#3b3b3b] mb-2">
        {department.name || "Unnamed Department"}
      </h3>

      {/* Risk Appetite */}
      <div className="mb-2">
        <span className="text-sm text-gray-600 font-semibold">Appetite: </span>
        <span
          className={`text-sm font-bold ${
            department.risk_appetite === "Hungry"
              ? "text-[#BB133E]"
              : department.risk_appetite === "Open"
              ? "text-[#D6606E]"
              : department.risk_appetite === "Cautious"
              ? "text-[#FED9B7]"
              : department.risk_appetite === "Minimalist"
              ? "text-[#00AFB9]"
              :"text-[#0081A7]"
              
          }`}
        >
          {department.risk_appetite || "Unknown"}
        </span>
      </div>

      {/* Number of Personnel */}
      <div className="mb-2">
        {/* <span className="text-sm text-gray-600 font-semibold">
          Number of Personnel:{" "}
        </span> */}
        <span className="text-sm text-black">
          {department.personnel_number || "0"}
        </span>
      </div>

      {/* Location */}
      <div className="mb-2">
        <span className="text-sm text-gray-600 font-semibold">Location: </span>
        <span className="text-sm text-black">
          {department.location || "Not Specified"}
        </span>
      </div>
    </div>
  );
};

export default DepartmentCard;
